import React from "react";
import Loader from 'react-loader-spinner'
import HttpService from '../../utils/Http.services';
import { checkTranslation, translate } from "../../utils/useful";

class ImageSelectInput extends React.Component {
    state = {
        options: [],
        isLoading: false
    }

    componentDidMount() {
        // console.log(this.props.data)
        this.init(true)
    }


    componentDidUpdate(prevProps) {

        // console.log(this.props.data)

        if (this.state.options != this.props.header.information.items && this.props.header.information.type === "local") {
            this.setState({ options: this.props.header.information.items })
        }
    }

    init(mount) {

        // console.log(this.props.data)

        // if(!mount){
        //     this.props.changeValue(this.props.header.key, null, this.props.extra) 
        // }
        if (this.props.header.information) {
            if (this.props.header.information.type === "local" || !this.props.header.information.type) {
                this.setState({ options: this.props.header.information.items })
            } else if (this.props.header.information.type === "api") {
                this.fetch()
            }
        }

    }



    fetch() {

        // console.log("HERE")
        // console.log(this.props.header.information.filter)
        let filter = this.props.header.information.filter
        if (this.props.header.information.sort) {
            filter.sort = this.props.header.information.sort
        }

        for (const [key, value] of Object.entries(filter)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
                // console.log("VAR")
            }
        }

        // console.log(filter)
        // console.log(this.props.variables)
        this.setState({ isLoading: true })
        HttpService.request(this.props.header.information.address, filter, (fetchResult, fetchError) => {
            if (fetchError) { return }
            console.log(fetchResult)
            var newData = []
            fetchResult.info.forEach(element => {

                var newTitle = this.spliter(element, this.props.header.information.fields.title)
                var newValue = this.spliter(element, this.props.header.information.fields.value)

                newData.push({ value: newValue, title: newTitle })
            });
            // console.log("NEW DATA")
            // console.log(newData)
            // setTimeout(() => {

            if (this.props.data != null) {
                let found = false
                // console.log(this.props.data)

                newData.forEach(element => {
                    // console.log(element.value)
                    if (element.value == this.props.data) {
                        found = true
                    }

                });

                if (found == false) {
                    // console.log("DWLKFJWLK")
                    // this.props.changeValue(this.props.header.key, null, this.props.extra)
                }

            }


            this.setState({
                options: newData,
                isLoading: false
            })
            // }, 1000);


        })

    }


    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            finalString = finalString[element]
        });
        return finalString
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] === condition) {
                return true
            }
        }
        return false
    }


    changeValue = (e) => {
        // console.log(e.value)
        let value = e.value

        if (this.props.data) {
            let dataValue = typeof this.props.data == "object" ? (this.props.data._id ?? this.props.data.id) : this.props.data

            if (dataValue == value) {
                value = null
            }

        }


        this.props.changeValue(this.props.header.key, value, this.props.extra)
    }


    formColBuilder(col) {
        let finalCol = '100%'


        if (col && this.props.width > 500) {
            finalCol = (100 / col) + '%'
        }

        // console.log(this.props.width / col )
        // if(this.props.width / col < 160){
        //     finalCol = '100%'
        // }

        return finalCol
    }


    render() {
        let dataValue = null
        if (this.props.data) {
            dataValue = typeof this.props.data == "object" ? (this.props.data._id ?? this.props.data.id) : this.props.data
        }
        let information = this.props.header?.information

        // console.log( dataValue)
        // console.log(this.props.header.information)
        return (
            <div className='w-100' style={{ position: 'relative' }}>
                <div className="d-flex m-0" style={{ position: 'relative', flexWrap: 'wrap' }}>
                    {/* <select value={dataValue} disabled={this.conditionalSettings('disabled', true)} onChange={e => { this.changeValue(e) }} className=' form-control' style={{ WebkitAppearance: 'none', border: 'none', boxShadow: 'none', backgroundColor: 'transparent', color: '#3b3a40', width: '100%', padding: 0 }}> */}
                    {/* <option disabled={this.props.header.information.required ? true : false} hidden={this.props.header.information.required ? true : false} value="">Select ...</option> */}
                    {Array.isArray(this.state.options) && this.state.options?.map((prop, index) => {

                        return (
                            <div key={index} className={' p-1 cursor-pointer '} onClick={() => this.changeValue(prop)} style={{ width: this.formColBuilder(information.col) }}>
                                <div className={"h-100 w-100 d-flex flex-column br-10 transition-all " + (information.imageOnSide ? ' d-flex ' : '')} style={{ border: dataValue == prop.value ? '1px dashed #1379FFdd' : (information.border ?? '1px dashed transparent'), backgroundColor: dataValue == prop.value ? ' #1379FF12' : information.backgroundColor, padding: information?.padding ?? (information.backgroundColor ? '10px 12px' : '2px') }}>
                                    <div className={"flexc" + (information.imageOnSide ? 'mt-1 mrd-3' : '')}>
                                        <img src={prop.image} height={information.imageSize ?? 50} width={information.imageSize ?? 50} style={{ objectFit: 'contain' }} alt="" />
                                    </div>
                                    <div className="mt-2 text-start">
                                        <p className="text-small  " style={{ fontWeight: information.fontWeight ?? 600, fontSize: information.fontSize ?? null }}>{checkTranslation(prop.title)}</p>
                                        {prop.description && (
                                            <p className="text-smaller mt-1">{checkTranslation(prop.description)}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    {/* </select> */}

                    {this.conditionalSettings('showInfo', true) && (
                        <p onClick={() => { if (!this.state.isLoading) { this.props.showInfo(this.props.header.information.filter, this.props.data, this.props.settings.url, this.props.settings.page) } }} style={{ fontSize: 13, color: this.state.isLoading ? '#789' : '#007aff', marginTop: 3, cursor: 'pointer', marginLeft: 3 }}>{translate('Show information')}</p>
                    )}

                    {this.state.isLoading && (
                        <div style={{ position: 'absolute', top: -2, right: 0 }}>
                            <Loader
                                type="ThreeDots"
                                color="#9ab"
                                height="25"
                                width="25"
                            />
                        </div>
                    )}

                </div>

            </div>
        );
    }
}

export default ImageSelectInput;
